import React, { Component } from 'react';
import everybodyIn from '../../img/Cubs_News_Bullseye_Final.png';
import Moment from 'moment';
import ReactPlayer from 'react-player/file';
import {
  contentfulItemAllowsExperience,
  getCurrentExperience,
} from '../../utils/visibility';

function getExperience() {
  return getCurrentExperience();
}

function isVisibleByExperience(item) {
  const experience = getExperience();
  return contentfulItemAllowsExperience(item, experience);
}

// Simple markdown-ish stripper (no dependencies).
function stripMarkdown(s) {
  if (!s) return '';
  return String(s)
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '') // images ![alt](url)
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links [text](url) -> text
    .replace(/<\/?[^>]+(>|$)/g, '') // HTML tags
    .replace(/[`*_>#-]/g, ' ') // common markdown chars
    .replace(/\s+/g, ' ')
    .trim();
}

function QueryNews(props) {
  Moment.locale('en');

  let temp = [];
  if (props.news) {
	  // Case A: passed the full query result (newsPageQuery)
	  if (Array.isArray(props.news.newsItems)) temp = props.news.newsItems;

	  // Case B: passed an object with shape { news: { newsItems: [...] } }
	  else if (props.news.news && Array.isArray(props.news.news.newsItems)) temp = props.news.news.newsItems;

	  // Case C: passed { newsItems: [...] } directly
	  else if (Array.isArray(props.newsItems)) temp = props.newsItems;
  }


  // filter by visibilityValue
  temp = temp.filter(isVisibleByExperience);

  temp.sort(function compare(a, b) {
    let dateA = new Date(a && a.date ? a.date : 0);
    let dateB = new Date(b && b.date ? b.date : 0);
    return dateB - dateA;
  });

  if (props.selectedMonth) {
    const m = parseInt(props.selectedMonth, 10);
    temp = temp.filter((item) => item && item.date && Moment(item.date).month() === m);
  }

  if (props.selectedYear) {
    const y = parseInt(props.selectedYear, 10);
    temp = temp.filter((item) => item && item.date && Moment(item.date).year() === y);
  }

  return (
    <ul>
      <div className="news-section">
        <div className="section-content row cubs-news">
          {temp.map(function (item, index) {
            const route = item && item.route ? item.route : '';
            const detailHref = '/cubs-news-departments/' + route;

            const teaserRaw = item && item.description ? stripMarkdown(item.description) : '';
            const teaser = teaserRaw ? teaserRaw.substring(0, 80) + '...' : '';

            const title = item && item.newsTitle ? item.newsTitle : 'News';
            const dateStr =
              item && item.date ? Moment(item.date).format('MM/DD/YYYY') : '';

            const deptText =
              item && Array.isArray(item.department) && item.department.length > 0
                ? 'Department: ' + item.department.map((d) => d && d.name ? d.name : '').filter(Boolean).join(', ')
                : null;

            // IMAGE TILE
            if (item && item.image && item.image.url) {
              return (
                <li key={index}>
                  <div className="col md-4 news flex-item">
                    <a href={detailHref}>
                      <div className="news-img-container">
                        <img src={item.image.url} alt="news" />
                      </div>
                    </a>
                    <h3>
                      <a href={detailHref}>{title}</a>
                    </h3>
                    <p>{dateStr}</p>
                    {deptText && <p>{deptText}</p>}
                    <div>
                      <div className="news-text">{teaser}</div>
                      <a href={detailHref}> Read More </a>
                    </div>
                  </div>
                </li>
              );
            }

            // NO IMAGE + NO VIDEO (fallback image)
            if (!item || !item.videoLink) {
              return (
                <li key={index}>
                  <div className="col md-4 news flex-item">
                    <a href={detailHref}>
                      <div className="news-img-container">
                        <img src={everybodyIn} alt="news" />
                      </div>
                    </a>
                    <h3>
                      <a href={detailHref}>{title}</a>
                    </h3>
                    <p>{dateStr}</p>
                    {deptText && <p>{deptText}</p>}
                    <div>
                      <div className="news-text">{teaser}</div>
                      <a href={detailHref}> Read More </a>
                    </div>
                  </div>
                </li>
              );
            }

            // VIDEO TILE
            return (
              <li key={index}>
                <div className="col md-4 news flex-item">
                  <a href={detailHref}>
                    <div className="news-img-container">
                      <div className="player-wrapper">
                        <ReactPlayer
                          config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                          className="react-player"
                          controls={true}
                          muted={true}
                          width="100%"
                          height="100%"
                          url={item.videoLink}
                        />
                      </div>
                    </div>
                  </a>
                  <h3>
                    <a href={detailHref}>{title}</a>
                  </h3>
                  <p>{dateStr}</p>
                  {deptText && <p>{deptText}</p>}
                  <div>
                    <div className="news-text">{teaser}</div>
                    <a href={detailHref}> Read More </a>
                  </div>
                </div>
              </li>
            );
          })}
        </div>
      </div>
    </ul>
  );
}

class allNews extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedMonth: '', selectedYear: '' };
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
  }

  handleMonthChange(event) {
    this.setState({ selectedMonth: event.target.value });
  }
  handleYearChange(event) {
    this.setState({ selectedYear: event.target.value });
  }

  render() {
    const news = this.props.news;
    let newsItems = [];

    if (news) {
      if (Array.isArray(news.newsItems)) newsItems = news.newsItems;
      else if (news.news && Array.isArray(news.news.newsItems)) newsItems = news.news.newsItems;
      else if (Array.isArray(this.props.newsItems)) newsItems = this.props.newsItems;
    }

    const visibleNewsItems = newsItems.filter(isVisibleByExperience);

    const months = Moment.months().map((month, index) => (
      <option key={index} value={index}>
        {month}
      </option>
    ));

    const years = Array.from(
      new Set(
        visibleNewsItems
          .filter((item) => item && item.date)
          .map((item) => Moment(item.date).year())
          .filter((year) => Number.isFinite(year))
      )
    ).sort((a, b) => b - a);

    const yearOptions = years.map((year, index) => (
      <option key={index} value={year}>
        {year}
      </option>
    ));

    return (
      <section className="section">
        <div className="container-fluid">
          <header className="section-header ">
            <div className="col">
              <h3 className="section-title row news-layout"> Looking Back</h3>
            </div>
          </header>

          <div className="row news-layout">
            <div className="col md-2 ">
              <div className="select-month-year">
                <div className="select-year">
                  <select value={this.state.selectedYear} onChange={this.handleYearChange}>
                    <option value="">Select Year</option>
                    {yearOptions}
                  </select>
                </div>

                <div className="select-month">
                  <select
                    disabled={!this.state.selectedYear}
                    value={this.state.selectedMonth}
                    onChange={this.handleMonthChange}
                  >
                    <option value="">Select Month</option>
                    {months}
                  </select>
                </div>
              </div>
            </div>

            <div className="col md-10 ">
              <QueryNews
                news={news}
                selectedMonth={this.state.selectedMonth}
                selectedYear={this.state.selectedYear}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default allNews;
